import { useEffect, useState } from "react"

import { NIRVANA_THEME } from "@front-shared/config/theme.config.ts"

export const useIsMobile = (
    mobileMediaQuery = NIRVANA_THEME.mediaQueries.sm,
) => {
    const [isMobile, setIsMobile] = useState<boolean>(false)

    useEffect(() => {
        const themeMobileWidth = parseInt(
            mobileMediaQuery.match(/\d+/g)?.[0] || "639",
        )

        const handleWindowSizeChange = () => {
            setIsMobile(window.innerWidth <= themeMobileWidth)
        }

        window.addEventListener("resize", handleWindowSizeChange)

        handleWindowSizeChange()

        return () => {
            window.removeEventListener("resize", handleWindowSizeChange)
        }
    }, [])

    return isMobile
}
